/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsBlogPost = {
      init: function ($section) {
        const $postSlider = $section.find('[data-slider]');
  
        $postSlider.flickity({
          wrapAround: true,
          initialIndex: 1,
          prevNextButtons: false,
          pageDots: false,
          watchCSS: true,
          cellAlign: 'center',
        });
  
        // Resize flickity when the slider is settled
        $postSlider.on('settle.flickity', function () {
          $postSlider.flickity('resize');
        });
        $postSlider.on( 'scroll.flickity', function( event, progress ) {
            $progressBar = $section.find(".slider_progrssbar");
            progress = Math.max( 0, Math.min( 1, progress ) );
            $progressBar.width( progress * 100 + '%' );
          });
      },
      unload: function ($section) {
        const $slider = $section.find('.flickity-enabled');
        $slider.flickity('destroy');
      }
    }
  
    /******/
  })()
    ;